import { FaMoon, FaSun } from 'react-icons/fa';
import './DarkmodeToggle.css';

function DarkModeToggle({ darkMode, toggleDarkMode }) {
    return (
        <button 
            className={`sun-toggle ${darkMode ? 'dark-mode' : 'light-mode'}`}
            onClick={toggleDarkMode}
            aria-label={`Switch to ${darkMode ? 'light' : 'dark'} mode`}
            title={`Switch to ${darkMode ? 'light' : 'dark'} mode`}
        >
            {darkMode ? <FaSun /> : <FaMoon />}
        </button>
    );
}

export default DarkModeToggle;